import Moment from 'moment';

import { useEffect, useReducer, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../common/services/customer/Actions';
import * as CustomerService from '../../../common/services/customer/Service';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { MaintenanceContractChartResultDTO } from '../../../common/types/dto/MaintenanceContractChartResultDTO';
import { MaintenanceContractUpgradeChartResultDTO } from '../../../common/types/dto/MaintenanceContractUpgradeChartResultDTO';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import { AppThunkDispatch } from '../../common/types';

import classNames from 'classnames';
import Notifications from 'react-notification-system-redux';
// import { Link } from 'react-router-dom';
import InlineSpinner from '../../../common/components/misc/InlineSpinner';
import { CustomerError } from '../../../common/services/customer/Types';
import { MaintenanceContractChartDTO } from '../../../common/types/dto/MaintenanceContractChartDTO';
import { MaintenanceContractUpgradeChartDTO } from '../../../common/types/dto/MaintenanceContractUpgradeChartDTO';
import { Utils } from '../../../common/utils';
import checkedImg from '../../assets/images/icons/Cinzentos/checked.jpg';
import AlertMessage from '../../common/Components/AlertMessage';
import CardsResizer from '../../common/Components/CardsResizer';
import PrimeCollapsible from '../../common/Components/PrimeCollapsible';

interface VehicleMaintenanceContractsState {
    maintenanceContracts: MaintenanceContractChartResultDTO | undefined;
    maintenanceContractUpgrades: MaintenanceContractUpgradeChartResultDTO | undefined;
    history: boolean;
    active: boolean;
    upgrade: boolean;
    sectionServiceInclusiveOpen: boolean;
    sectionServicePlusOpen: boolean;
    sectionServiceNextOpen: boolean;
    sectionServiceRepairOpen: boolean;
    vehcode: number;
    submitErrorText: string;
    showLoadingContracts: boolean;
    showLoadingUpgrades: boolean;
    licensePlate: string;
    vin: string;
}

export interface MaintenanceContractsExpandableProps {
    history: boolean;
    onHistoryClick: () => void;
}

export interface MaintenanceContractsActiveExpandableProps {
    active: boolean;
    onActiveClick: () => void;
}

export interface MaintenanceContractUpgradesExpandableProps {
    upgrade: boolean;
    onUpgradeClick: () => void;
    sectionServiceInclusiveOpen: boolean;
    sectionServicePlusOpen: boolean;
    sectionServiceNextOpen: boolean;
    sectionServiceRepairOpen: boolean;
    toggleSectionServiceInclusive: () => void;
    toggleSectionServicePlus: () => void;
    toggleSectionServiceNext: () => void;
    toggleSectionServiceRepair: () => void;
}

export interface VehicleMaintenanceContractsProps {
    vehcode: number;
    licensePlate: string;
    vin: string;
}

interface ReduxStateProps {
    isCommunicating: boolean;
    vehicleMaintenanceContractUpgradesIsCommunicating: boolean;
    vehicleMaintenanceContractsIsCommunicating: boolean;
    vehicleMaintenanceContracts: MaintenanceContractChartResultDTO;
    vehicleMaintenanceContractUpgrades: MaintenanceContractUpgradeChartResultDTO;

    maintenancePDFIsCommunicating: boolean;
    maintenancePDF: Blob | undefined;

    dispatch: AppThunkDispatch;
}

interface ReduxDispatchProps {
    customerActions: typeof Actions;
    customerServiceActions: CustomerService.ServiceActions;
}

type VehicleMaintenanceContractsProperties =
    ReduxStateProps
    & ReduxDispatchProps
    & VehicleMaintenanceContractsProps;

const VehicleMaintenanceContracts: React.FC<VehicleMaintenanceContractsProperties> = (Props) => {
    const initialState: VehicleMaintenanceContractsState = {
        maintenanceContracts: undefined,
        maintenanceContractUpgrades: undefined,
        history: true,
        active: true,
        upgrade: true,
        sectionServiceInclusiveOpen: false,
        sectionServicePlusOpen: false,
        sectionServiceNextOpen: false,
        sectionServiceRepairOpen: false,
        vehcode: -1,
        submitErrorText: '',
        showLoadingContracts: false,
        showLoadingUpgrades: false,
        licensePlate: '',
        vin: '',
    };
    const [state, setState]: [VehicleMaintenanceContractsState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );
    const [tab, setTab] = useState('1');
    const { t } = useTranslation();

    useEffect(() => {
        if (!state.maintenanceContracts && !state.maintenanceContractUpgrades && (!Props.vehcode || Props.vehcode === -1)) {
            setState({
                maintenanceContracts: [],
                maintenanceContractUpgrades: [],
            });
        } else {
            if (Props.vehcode === state.vehcode) {
                return;
            }
            setState({
                vehcode: Props.vehcode,
                maintenanceContracts: undefined,
                maintenanceContractUpgrades: undefined,
                submitErrorText: '',
                showLoadingContracts: false,
                showLoadingUpgrades: false,
                licensePlate: Props.licensePlate,
                vin: Props.vin,
            });

            try {
                if (Props.licensePlate.length === 8 || Props.vin.length === 17) {
                    setState({
                        showLoadingUpgrades: true,
                    });
                    // Unautheticated users should not view Active Packages, only available ones:
                    // Props.customerServiceActions.vehicleMaintenanceContractsByPlateOrVin(Props.licensePlate, Props.vin);
                    Props.customerServiceActions.vehicleMaintenanceContractUpgradesByPlateOrVin(Props.licensePlate, Props.vin);
                } else if (Props.vehcode > 0) {
                    setState({
                        showLoadingContracts: true,
                        showLoadingUpgrades: true,
                    });
                    Props.customerServiceActions.vehicleMaintenanceContracts(Props.vehcode);
                    Props.customerServiceActions.vehicleMaintenanceContractUpgrades(Props.vehcode);
                }
            } catch (error) {
                let exceptionErrorMsg: string = t('exception:UnknownException');
                if (error instanceof CustomerError) {
                    const exceptionType: string = error.customerErrorInfo.exceptionType || 'UnknownException';
                    exceptionErrorMsg = t(`exception:${exceptionType.split('.').pop()}`);
                }
                setState({
                    submitErrorText: exceptionErrorMsg,
                    maintenanceContracts: [],
                    maintenanceContractUpgrades: [],
                    showLoadingContracts: false,
                    showLoadingUpgrades: false,
                });
                Props.dispatch(Notifications.error({
                    title: t('error'),
                    message: exceptionErrorMsg,
                    position: 'tc',
                    autoDismiss: 5,
                }));
            }
        }
    });

    useEffect(() => {
        if (Props.vehicleMaintenanceContractUpgrades) {
            if (Props.vehicleMaintenanceContractUpgrades.vehcode !== Props.vehcode) {
                return;
            }
            setState({
                maintenanceContractUpgrades: Props.vehicleMaintenanceContractUpgrades,
                showLoadingUpgrades: false,
            });
        }
    }, [Props.vehicleMaintenanceContractUpgrades]);

    useEffect(() => {
        if (Props.vehicleMaintenanceContracts) {
            if (Props.vehicleMaintenanceContracts.vehcode !== Props.vehcode) {
                return;
            }
            setState({
                maintenanceContracts: Props.vehicleMaintenanceContracts,
                showLoadingContracts: false,
            });
        }
    }, [Props.vehicleMaintenanceContracts]);

    useEffect(() => {
        if (Props.maintenancePDF && !Props.maintenancePDFIsCommunicating) {
            Utils.saveData(Props.maintenancePDF, `${state.vehcode}.pdf`);
        }
    }, [Props.maintenancePDF, Props.maintenancePDFIsCommunicating]);

    function onUpgradeClick() {
        setState({
            upgrade: !state.upgrade,
        });
    }

    function toggleSectionServiceInclusive() {
        if (!state.sectionServiceInclusiveOpen) {
            setState({
                sectionServiceInclusiveOpen: true,
            });
        } else {
            setState({
                sectionServiceInclusiveOpen: false,
            });
        }
    }

    function toggleSectionServicePlus() {
        if (!state.sectionServicePlusOpen) {
            setState({
                sectionServicePlusOpen: true,
            });
        } else {
            setState({
                sectionServicePlusOpen: false,
            });
        }
    }

    function toggleSectionServiceNext() {
        if (!state.sectionServiceNextOpen) {
            setState({
                sectionServiceNextOpen: true,
            });
        } else {
            setState({
                sectionServiceNextOpen: false,
            });
        }
    }

    function toggleSectionServiceRepair() {
        if (!state.sectionServiceRepairOpen) {
            setState({
                sectionServiceRepairOpen: true,
            });
        } else {
            setState({
                sectionServiceRepairOpen: false,
            });
        }
    }

    const maintenanceContractUpgradesExpandable: MaintenanceContractUpgradesExpandableProps = {
        upgrade: state.upgrade,
        onUpgradeClick,
        sectionServiceInclusiveOpen: state.sectionServiceInclusiveOpen,
        toggleSectionServiceInclusive,
        sectionServicePlusOpen: state.sectionServicePlusOpen,
        toggleSectionServicePlus,
        sectionServiceNextOpen: state.sectionServiceNextOpen,
        toggleSectionServiceNext,
        sectionServiceRepairOpen: state.sectionServiceRepairOpen,
        toggleSectionServiceRepair,
    };

    const buildVehicleMaintenanceContracts = () => {
        const historyRows: JSX.Element[] = [];
        const activeRows: JSX.Element[] = [];
        let content = null;

        const checkedTd = (
            <td align="center" style={{ verticalAlign: 'middle' }} className={'pacote-manutencao-tabela-img'}>
                <img src={checkedImg} />
            </td>);
        const emptyTd = (<td />);
        if (state.maintenanceContracts && state.maintenanceContracts.chartList) {
            state.maintenanceContracts.chartList.forEach((i: MaintenanceContractChartDTO, idx: any) => {
                content = (
                    <div className={'dados-pacote'} key={idx}>
                        <label className={classNames(['nome', 'margin-bottom-1'])}>
                            {i.description ? i.description : ''}
                        </label>
                        <div className={'cell'}>
                            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                                <div className={classNames(['cell', 'large-3'])}>
                                    <table className={classNames(['checked-list'])}>
                                        <tbody>
                                            <tr className={classNames({ checked: i.service })}>
                                                {i.service ? checkedTd : emptyTd}
                                                <td align="center" style={{ verticalAlign: 'middle' }}>{t('contractsinvoices:maintenance.service')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={classNames(['cell', 'large-3'])}>
                                    <table className={classNames(['checked-list'])}>
                                        <tbody>
                                            <tr className={classNames({ checked: i.servicePlus })}>
                                                {i.servicePlus ? checkedTd : emptyTd}
                                                <td align="center" style={{ verticalAlign: 'middle' }}>{t('contractsinvoices:maintenance.servicePlus')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={classNames(['cell', 'large-3'])}>
                                    <table className={classNames(['checked-list'])}>
                                        <tbody>
                                            <tr className={classNames({ checked: i.serviceNext })}>
                                                {i.serviceNext ? checkedTd : emptyTd}
                                                <td align="center" style={{ verticalAlign: 'middle' }}>{t('contractsinvoices:maintenance.serviceNext')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={classNames(['cell', 'large-3'])}>
                                    <table className={classNames(['checked-list'])}>
                                        <tbody>
                                            <tr className={classNames({ checked: i.repairInclusive })}>
                                                {i.repairInclusive ? checkedTd : emptyTd}
                                                <td align="center" style={{ verticalAlign: 'middle' }}>{t('contractsinvoices:maintenance.RepairInc')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={classNames(['cell large-3', 'small-2', 'text-left'])}>
                                    <label htmlFor="lbl-codigo">{t('contractsinvoices:maintenance.code')}</label>
                                    <span>{i.maintenanceContractPackKey ? i.maintenanceContractPackKey : ''}</span>
                                </div>
                                <div className={classNames(['cell', 'large-3', 'small-6', 'text-left'])}>
                                    <label htmlFor="lbl-codigo">{t('contractsinvoices:maintenance.startPackageDate')}</label>
                                    <span>{i.maintenanceContractStartDate ? Moment(i.maintenanceContractStartDate).format('YYYY-MM-DD') : ''}</span>
                                </div>

                                <div className={classNames(['cell', 'large-3', 'small-4', 'text-left'])}>
                                    <label htmlFor="lbl-codigo">{t('contractsinvoices:maintenance.endPackageDate')}</label>
                                    <span>{i.limitDate ? Moment(i.limitDate).format('YYYY-MM-DD') : ''}</span>
                                </div>
                                <div className={classNames(['cell', 'large-3'])} />
                            </div>
                        </div>
                    </div>
                );

                i.isActive ? activeRows.push(content) : historyRows.push(content);
            });
        }

        if (state.maintenanceContracts && state.maintenanceContracts.chartList && state.maintenanceContracts.chartList.length > 0) {
            return (
                <React.Fragment>
                    {activeRows.length > 0 && (
                        <div className={classNames(['columns', 'medium-12'])}>
                            <PrimeCollapsible open={true} trigger={<h4>{t('contractsinvoices:maintenance.active')} ({activeRows.length})</h4>}>
                                {activeRows}
                            </PrimeCollapsible>
                        </div>
                    )}
                    {historyRows.length > 0 && (
                        <div className={classNames(['columns', 'medium-12', { 'margin-top-1': activeRows.length > 0 }])}>
                            <PrimeCollapsible trigger={<h4>{t('contractsinvoices:maintenance.history')} ({historyRows.length})</h4>}>
                                {historyRows}
                            </PrimeCollapsible>
                        </div>
                    )}
                    <div className={classNames(['columns', 'medium-12'])}>
                        <hr />
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    };

    const buildCard = (idx: number, price: number, description?: string | null) => {
        return (
            <div className={classNames(['cell', 'medium-3', 'pacotesOferta'])} data-equalizer-watch="bloco-pacotes" key={idx}>
                <div className={'card'}>
                    <div className={classNames(['card-section', 'info'])} style={{ height: 'auto' }}>
                        <p>
                            {description}
                        </p>
                    </div>
                    <div className={classNames(['card-section', 'preco'])}>
                        <p>
                            {price + '€'}
                        </p>
                    </div>
                </div>
            </div>
        );
    };

    function GoToStore() {
        window.open(`${config.StoreURL}`, '_blank');
    }

    const buildVehicleMaintenanceContractUpgrades = () => {
        const dataServiceInclusive: MaintenanceContractUpgradeChartDTO[] = [];
        const dataServicePlus: MaintenanceContractUpgradeChartDTO[] = [];
        const dataServiceNext: MaintenanceContractUpgradeChartDTO[] = [];
        const dataServiceRepair: MaintenanceContractUpgradeChartDTO[] = [];

        if (state.maintenanceContractUpgrades && state.maintenanceContractUpgrades.chartList) {
            state.maintenanceContractUpgrades.chartList.forEach((item) => {
                if (item.type === 'Service') {
                    dataServiceInclusive.push(item);
                }
                if (item.type === 'ServicePlus') {
                    dataServicePlus.push(item);
                }
                if (item.type === 'ServiceNext') {
                    dataServiceNext.push(item);
                }
                if (item.type === 'RepairInclusive') {
                    dataServiceRepair.push(item);
                }
            });
        }

        const tableServiceInclusive = dataServiceInclusive.map((i, idx) => buildCard(idx, i.price, i.description));
        const tableServicePlus = dataServicePlus.map((i, idx) => buildCard(idx, i.price, i.description));
        const tableServiceNext = dataServiceNext.map((i, idx) => buildCard(idx, i.price, i.description));
        const tableServiceRepair = dataServiceRepair.map((i, idx) => buildCard(idx, i.price, i.description));

        if (state.maintenanceContractUpgrades && maintenanceContractUpgradesExpandable.upgrade && state.maintenanceContractUpgrades.chartList && state.maintenanceContractUpgrades.chartList.length > 0) {
            const countService = state.maintenanceContractUpgrades.chartList.filter((x) => x.type === 'Service').length;
            const countServicePlus = state.maintenanceContractUpgrades.chartList.filter((x) => x.type === 'ServicePlus').length;
            const countServiceNext = state.maintenanceContractUpgrades.chartList.filter((x) => x.type === 'ServiceNext').length;
            const countRepairInclusive = state.maintenanceContractUpgrades.chartList.filter((x) => x.type === 'RepairInclusive').length;
            return (
                <div className={classNames(['columns', 'medium-12'])}>
                    <label className={classNames(['seleccionarPacotesOferta', 'show-for-small-only'])}>
                        <select id="pacotesSel" value={tab} onChange={(e) => setTab(e.target.value)}>
                            <option value="1">{t('contractsinvoices:maintenance.servInc')}</option>
                            <option value="2">{t('contractsinvoices:maintenance.servIncPlus')}</option>
                            <option value="3">{t('contractsinvoices:maintenance.servIncNext')}</option>
                            <option value="4">{t('contractsinvoices:maintenance.extWarranty')}</option>
                        </select>
                    </label>
                    <div className={classNames(['quantidade-pacotes-disponiveis', 'show-for-small-only'])}>
                        <label>{t('contractsinvoices:maintenance.availablePackages')}: </label><label className={'stat'}>{state.maintenanceContractUpgrades.chartList.length}</label>
                    </div>
                    <ul className={classNames(['tabs', 'hide-for-small-only'])} data-active-collapse="true" id="collapsing-tabs">
                        <li className={'tabs-title'}>
                            <div className={'quantidade-pacotes-disponiveis'}>
                                <label>{t('contractsinvoices:maintenance.availablePackages')}: </label><label className={'stat'}>{state.maintenanceContractUpgrades.chartList.length}</label>
                            </div>
                        </li>
                        <li className={classNames(['tabs-title', { 'is-active': tab === '1' }])}>
                            <a onClick={() => setTab('1')} className={classNames([{ 'text-bold': tab === '1' }])}>
                                <span>{t('contractsinvoices:maintenance.servInc')}</span>
                                {countService > 0 && <span> ({countService})</span>}
                            </a>
                        </li>
                        <li className={classNames(['tabs-title', { 'is-active': tab === '2' }])}>
                            <a onClick={() => setTab('2')} className={classNames([{ 'text-bold': tab === '2' }])}>
                                <span>{t('contractsinvoices:maintenance.servIncPlus')}</span>
                                {countServicePlus > 0 && <span> ({countServicePlus})</span>}
                            </a>
                        </li>
                        <li className={classNames(['tabs-title', { 'is-active': tab === '3' }])}>
                            <a onClick={() => setTab('3')} className={classNames([{ 'text-bold': tab === '3' }])}>
                                <span>{t('contractsinvoices:maintenance.servIncNext')}</span>
                                {countServiceNext > 0 && <span> ({countServiceNext})</span>}
                            </a>
                        </li>
                        <li className={classNames(['tabs-title', { 'is-active': tab === '4' }])}>
                            <a onClick={() => setTab('4')} className={classNames([{ 'text-bold': tab === '4' }])}>
                                <span>{t('contractsinvoices:maintenance.extWarranty')}</span>
                                {countRepairInclusive > 0 && <span> ({countRepairInclusive})</span>}
                            </a>
                        </li>
                    </ul>
                    {tab === '1' && (
                        <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                            <div className={classNames(['tabs-panel', 'is-active'])} id="panelServiceInclusive">
                                <PrimeCollapsible trigger={t('contractsinvoices:maintenance.infoSI1')} renderAccordionTags={true} accordionClassName={'margin-top-1'} renderSelfAccordionArrows={true}>
                                    <ol>
                                        <li>{t('contractsinvoices:maintenance.infoSI2')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSI3')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSI4')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSI5')}</li>
                                    </ol>
                                    <br />
                                    <p>{t('contractsinvoices:maintenance.infoSI6')}</p>
                                    <p>{t('contractsinvoices:maintenance.infoSI7')}</p>
                                    <p>{t('contractsinvoices:maintenance.infoSI8')}</p>
                                </PrimeCollapsible>
                                <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                                    {tableServiceInclusive.length > 0 ? (
                                        <div className={classNames(['grid-x', 'grid-margin-x'])} data-equalizer="bloco-pacotes" data-resize="bloco-pacotes" data-mutate="bloco-pacotes" data-events="mutate">
                                            {tableServiceInclusive}
                                        </div>) : <AlertMessage type={'secondary'} msg={t(`contractsinvoices:packs.notFoundSimple`)} />}
                                </div>
                            </div>
                        </div>
                    )}
                    {tab === '2' && (
                        <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                            <div className={classNames(['tabs-panel', 'is-active'])} id="panelServiceInclusive">
                                <PrimeCollapsible trigger={t('contractsinvoices:maintenance.infoSIP1')} renderAccordionTags={true} accordionClassName={'margin-top-1'}>
                                    <ol>
                                        <li>{t('contractsinvoices:maintenance.infoSIP2')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIP3')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIP4')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIP5')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIP6')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIP7')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIP8')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIP9')}</li>
                                    </ol>
                                    <br />
                                    <p>{t('contractsinvoices:maintenance.infoSIP10')}</p>
                                    <p>{t('contractsinvoices:maintenance.infoSIP11')}</p>
                                    <p>{t('contractsinvoices:maintenance.infoSIP12')}</p>
                                </PrimeCollapsible>
                                <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                                    {tableServicePlus.length > 0 ? (
                                        <div className={classNames(['grid-x', 'grid-margin-x'])} data-equalizer="bloco-pacotes" data-resize="bloco-pacotes" data-mutate="bloco-pacotes" data-events="mutate">
                                            {tableServicePlus}
                                        </div>) : <AlertMessage type={'secondary'} msg={t(`contractsinvoices:packs.notFoundSimple`)} />}
                                </div>
                            </div>
                        </div>
                    )}
                    {tab === '3' && (
                        <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                            <div className={classNames(['tabs-panel', 'is-active'])} id="panelServiceInclusive">
                                <PrimeCollapsible trigger={t('contractsinvoices:maintenance.infoSIN1')} renderAccordionTags={true} accordionClassName={'margin-top-1'}>
                                    <p>{t('contractsinvoices:maintenance.infoSIN2')}</p>
                                    <ol>
                                        <li>{t('contractsinvoices:maintenance.infoSIN3')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIN4')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIN5')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIN6')}</li>
                                    </ol>
                                    <br />
                                    <p>{t('contractsinvoices:maintenance.infoSIN7')}</p>
                                    <p>{t('contractsinvoices:maintenance.infoSIN8')}</p>
                                    <ol>
                                        <li>{t('contractsinvoices:maintenance.infoSIN9')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIN10')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIN11')}</li>
                                        <li>{t('contractsinvoices:maintenance.infoSIN12')}</li>
                                    </ol>
                                    <br />
                                    <p>{t('contractsinvoices:maintenance.infoSIN13')}</p>
                                </PrimeCollapsible>
                                <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                                    {tableServiceNext.length > 0 ? (
                                        <div className={classNames(['grid-x', 'grid-margin-x'])} data-equalizer="bloco-pacotes" data-resize="bloco-pacotes" data-mutate="bloco-pacotes" data-events="mutate">
                                            {tableServiceNext}
                                        </div>) : <AlertMessage type={'secondary'} msg={t(`contractsinvoices:packs.notFoundSimple`)} />}
                                </div>
                            </div>
                        </div>
                    )}
                    {tab === '4' && (
                        <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                            <div className={classNames(['tabs-panel', 'is-active'])} id="panelServiceInclusive">
                                <PrimeCollapsible trigger={t('contractsinvoices:maintenance.infoEW1')} renderAccordionTags={true} accordionClassName={'margin-top-1'}>
                                    <ol>
                                        <li>{t('contractsinvoices:maintenance.infoEW2')}</li>
                                    </ol>
                                    <br />
                                    <p>{t('contractsinvoices:maintenance.infoEW3')}</p>
                                    <p>{t('contractsinvoices:maintenance.infoEW4')}</p>
                                </PrimeCollapsible>
                                <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                                    {tableServiceRepair.length > 0 ? (
                                        <div className={classNames(['grid-x', 'grid-margin-x'])} data-equalizer="bloco-pacotes" data-resize="bloco-pacotes" data-mutate="bloco-pacotes" data-events="mutate">
                                            {tableServiceRepair}
                                        </div>) : <AlertMessage type={'secondary'} msg={t(`contractsinvoices:packs.notFoundSimple`)} />}
                                </div>
                            </div>
                        </div>
                    )}
                    { /*
                    <div className={classNames(['columns', 'medium-12', 'margin-top-2'])}>
                        <label>{t(`contractsinvoices:packs.footer1`)}</label>
                        <label>{t(`contractsinvoices:packs.footer2`)}</label>
                        <label>{t(`contractsinvoices:packs.footer3`)}</label>
                    </div>
                    */ }
                    <p className={'margin-top-2'}>
                        <span>
                            {t(`contractsinvoices:moreInfoFooter`)} &nbsp;
                            <a href={config.AdditionalInfoMaintenance} target="_blank">{t('contractsinvoices:packs.additionalInfo')}</a>
                        </span>
                    </p>
                    <button className={classNames(['button', 'bttSubscrever'])} onClick={() => GoToStore()} onSubmit={() => GoToStore()}>
                        <span>{t('contractsinvoices:packs.gotoStore')}</span>
                    </button>
                    <p>
                        <span>
                            {t('contractsinvoices:packs.gotoStoreAsterisk')}
                        </span>
                    </p>
                </div>
            );
        } else {
            return (
                <div className={classNames(['columns', 'medium-12'])}>
                    <AlertMessage type={'secondary'} msg={t('contractsinvoices:maintenance.contractUpgradesEmpty')} />
                </div>
            );
        }
    };

    if (Props.vehicleMaintenanceContractsIsCommunicating || Props.vehicleMaintenanceContractUpgradesIsCommunicating || state.showLoadingContracts || state.showLoadingUpgrades) {
        return (
            <div className={classNames(['columns', 'medium-12', 'margin-top-2'])}>
                <InlineSpinner size={'100px'} />
            </div>
        );
    }
    return (
        <React.Fragment>
            <div className={classNames(['columns', 'medium-12'])}>
                <h3 className={'text-bold'}>{t('contractsinvoices:maintenance.header2')}</h3>
                <label>{t('contractsinvoices:maintenance.note')}</label>
            </div>
            <div className={classNames(['columns', 'medium-12'])}>
                <hr />
            </div>
            <div className="error-message">{state.submitErrorText}</div>
            {state.maintenanceContracts && state.vehcode && state.vehcode !== -1 && <React.Fragment>{buildVehicleMaintenanceContracts()}</React.Fragment>}
            {state.maintenanceContractUpgrades && state.vehcode && state.vehcode !== -1 && <React.Fragment>{buildVehicleMaintenanceContractUpgrades()}</React.Fragment>}
            <CardsResizer trigger1={Props.vehicleMaintenanceContracts} trigger2={tab} trigger3={Props.vehicleMaintenanceContractUpgrades} />
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    isCommunicating: store.customerState.updateCustomer.isCommunicating,
    vehicleMaintenanceContracts: store.customerState.vehicleMaintenanceContracts.data,
    vehicleMaintenanceContractUpgrades: store.customerState.vehicleMaintenanceContractUpgrades.data,
    vehicleMaintenanceContractUpgradesIsCommunicating: store.customerState.vehicleMaintenanceContractUpgrades.isCommunicating,
    vehicleMaintenanceContractsIsCommunicating: store.customerState.vehicleMaintenanceContracts.isCommunicating,
    maintenancePDFIsCommunicating: store.customerState.vehicleMaintenanceContractPDF.isCommunicating,
    maintenancePDF: store.customerState.vehicleMaintenanceContractPDF.data,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    customerActions: bindActionCreators(Actions, dispatch),
    customerServiceActions: CustomerService.bindServiceActionCreators(config, dispatch),
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleMaintenanceContracts);
